export default __webpack_public_path__ + "static/media/peryscope.942a8a07.svg";